<template>
  <div class="navbar-header-model" v-if="tabsParts.length">
    <ClientOnly>
      <tabs v-model="selectedTab">
        <tab
          :style="`width:${100 / (tabsParts.length + 1)}%`"
          v-for="(tab, i) in tabsParts"
          :key="`t${i}`"
          :val="i"
          :label="tab.name"
          :indicator="true"
        />
      </tabs>
    </ClientOnly>
    <ClientOnly>
      <tab-panels v-model="selectedTab" :animate="true" :swipeable="true" >
        <tab-panel v-for="(tab, i) in tabsParts" :key="`tp${i}`" :val="i">
          <div class="row">
            <div v-for="(part, j) in tab.sessions" :key="j" class="px-2 pt-3">
              <div
                :class="
                  part.block === 'false'
                    ? sessionActive == j && changeSelectedTab == i
                      ? 'card-box-active rounded-pill'
                      : 'card-box rounded-pill'
                    : 'card-box-block rounded-pill'
                "
              >
                <div
                  v-if="part.block === 'true'"
                  :class="
                    part.block === 'false'
                      ? 'part-name'
                      : 'part-name-block w-100'
                  "
                  @click="
                  part.block === 'true'
                      ? showModalPlans(
                          'Clicar em uma sessão de fotos bloqueada - Mobile'
                        )
                      : emits('changeSession', { part: i, session: j })
                  "
                >
                  <div class="d-flex align-items-center">
                    <div class="col-5 text-center">{{ part.name }}</div>
                    <div class="col-7 text-center">
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-lg px-4"
                      >
                        {{ translate.subscribeNow }}
                        <font-awesome
                          :icon="['fas', 'lock']"
                          size="lg"
                          style="color: #b20000; margin-left: 5px"
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  :class="
                    part.block === 'false' ? 'part-name' : 'part-name-block'
                  "
                  @click="
                    part.block === 'true'
                      ? showModalPlans(
                          'Clicar em uma sessão de fotos bloqueada - Mobile'
                        )
                      : emits('changeSession', { part: i, session: j })
                  "
                >
                  {{ part.name }}
                </div>
              </div>
            </div>
          </div>
        </tab-panel>
      </tab-panels>
    </ClientOnly>
    <hr />
  </div>
</template>
<script lang="ts" setup>
import { Tabs, Tab, TabPanels, TabPanel } from "vue3-tabs";

const emits = defineEmits(["changeSession", "showModalSubscribePlans"]);
const props = defineProps([
  "parts",
  "translate",
  "sessionActive",
  "changeSelectedTab",
]);

const tabsParts = computed(() => props.parts);
const selectedTab = ref(props.changeSelectedTab);

function showModalPlans(acionador: string) {
  emits("showModalSubscribePlans");
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "paywall",
    paywall: { acionador: acionador },
  });
}
</script>
<style scoped>
.tabs :deep(.tab) {
  padding: 15px 6px;
  font-weight: bold;
  font-size: 13px;
}

.tab-panels :deep(.tab-panel) {
  width: 98%;
  cursor: pointer;
}

.navbar-header-model .tabs > .active {
  color: #b20000;
  border-color: #b20000;
  background-color: #fafafa;
}

.button--more svg {
  color: #b20000;
}

.button--more {
  font-family: "Exo-2";
  font-weight: bold;
  color: #898989;
  font-size: 16px;
}

.small svg {
  margin-right: 5px;
}

.card-box {
  width: 100%;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: 1px solid #cccccc;
}

.card-box-active {
  width: 100%;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: 2px solid #b20000;
}

.card-box-block {
  width: 100%;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cccccc;
  background-color: #eee;
}

.part-name {
  font-size: 16px;
  color: #b20000;
  font-family: "Exo-2";
  font-weight: 900;
}

.part-name-block {
  font-size: 16px;
  color: #cccccc;
  font-family: "Exo-2";
  padding-top: 2px;
  font-weight: 700;
}

.fa-lock {
  color: #b20000;
}

.disable {
  cursor: not-allowed;
}

.btn-outline-secondary {
  font-size: 15px;
  color: white;
  border-radius: 30px;
  background-color: black;
  border: none;
}
</style>
